export enum AccessChangeTypes {
  NoChange,
  AddAccess,
  RemoveExpiration,
  AddExpiration,
}

export function getAccessChangeTypeString(changeType: AccessChangeTypes): string {
  switch (changeType) {
    case AccessChangeTypes.NoChange:
      return "No Change";
    case AccessChangeTypes.AddAccess:
      return "Add Access";
    case AccessChangeTypes.RemoveExpiration:
      return "Remove Expiration";
    case AccessChangeTypes.AddExpiration:
      return "Add Expiration";
  }
}

export interface IIntegrationAccessCollection {
  ErrorLoadingProposedAccess: boolean;
  Objects: IIntegrationObjectCore[];
}

export interface IIntegrationObjectCore {
  Module: string;
  Object: string;
  IsDeleteAllowed: boolean;
  DeleteExpirationDate: Date | null;
  ProposedDeleteAccess: AccessChangeTypes;
  Fields: IIntegrationFieldCore[];
}

export interface IIntegrationFieldCore {
  Field: string;
  IsReadAllowed: boolean;
  ReadExpirationDate: Date | null;
  ProposedReadAccess: AccessChangeTypes;
  IsCreateAllowed: boolean;
  CreateExpirationDate: Date | null;
  ProposedCreateAccess: AccessChangeTypes;
  IsUpdateAllowed: boolean;
  UpdateExpirationDate: Date | null;
  ProposedUpdateAccess: AccessChangeTypes;
}
